import React from "react";
import { Clock } from "lucide-react";
import { snoozeTargets } from "../lib/resurface";

// One-tap snooze. Each chip updates the item's suggested_datetime to a fixed offset.
export function SnoozeChips({ entryId, onSnooze }) {
  const targets = snoozeTargets();
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={`snooze-${entryId}`}>
      <span className="inline-flex items-center gap-1 text-xs font-semibold text-[var(--ink4)] mr-0.5">
        <Clock size={12} strokeWidth={2} /> Snooze
      </span>
      {targets.map((t) => (
        <button
          key={t.key}
          type="button"
          data-testid={`snooze-${t.key}-${entryId}`}
          onClick={() => onSnooze(t.iso)}
          className="rounded-full border border-[var(--line)] bg-[var(--surface)] px-3 py-1 text-xs font-semibold text-[var(--ink2)] hover:border-[var(--pine)] hover:text-[var(--pine)] transition-all duration-200"
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
